import { Tab, Tabs } from "react-bootstrap";
import SCRTypeManager from "./SCRTypeManager";
import "./SCRSettings.css";

const tabTitle = (icon, label) => (
  <span className="scr-settings__tab-label">
    <i className={`fas ${icon}`} aria-hidden="true" />
    {label}
  </span>
);

const SCRSettingsTab = () => {
  return (
    <div className="scr-settings">
      <div className="scr-settings__header">
        <div className="scr-settings__header-main">
          <span className="scr-settings__header-icon">
            <i className="fas fa-cogs" aria-hidden="true" />
          </span>
          <div className="scr-settings__header-text">
            <h5 className="mb-0">
              <b>SCR Configuration</b>
            </h5>
            <p className="text-muted mb-0">
              Configure distributor-specific adjustment types and Non-VizLink payment
              types used during SCR operations.
            </p>
          </div>
        </div>
      </div>

      <Tabs
        defaultActiveKey="AdjustmentTypes"
        id="scr-settings-tabs"
        className="mb-2"
        mountOnEnter
      >
        <Tab eventKey="AdjustmentTypes" title={tabTitle("fa-sliders-h", "Adjustment Types")}>
          <SCRTypeManager kind="adjustment" />
        </Tab>
        <Tab
          eventKey="PaymentTypes"
          title={tabTitle("fa-money-bill-wave", "Non-VizLink Payment Types")}
        >
          <SCRTypeManager kind="payment" />
        </Tab>
      </Tabs>
    </div>
  );
};

export default SCRSettingsTab;
